module.exports = __webpack_public_path__ + "img/effects-20.3a9dd18a.png";